const LOAD_LIST_URL = '/geo/city/data/load-popular-list';

const API_CITIES_IN_MODAL_NAME = 'apiCitiesInModal';
const REDUCER_CITIES_IN_MODAL_NAME = 'citiesInModal';

export {
  LOAD_LIST_URL,

  API_CITIES_IN_MODAL_NAME,
  REDUCER_CITIES_IN_MODAL_NAME,
};
